import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteEstadoDeTramite,
  getEstadosDeTramite,
  patchEstadoDeTramite,
  postEstadoDeTramite,
} from 'api/configuracion/estadoDeTramite';

// eslint-disable-next-line react/prop-types
const esstadosDeLosTramites = ({ permission }) => (
  <PlainCRUD
    title="Estados de los tramites"
    permission={permission}
    get={getEstadosDeTramite}
    post={postEstadoDeTramite}
    patch={patchEstadoDeTramite}
    delete={deleteEstadoDeTramite}
    withoutState
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default esstadosDeLosTramites;
